import toString from './toString';

const toStringWithoutQuestions = toString.with({
  OneOf: (label, options, answer) => (answer ? `${answer.label}${answer.child ? ` (${answer.child})` : ''}` : null),
});

export default toStringWithoutQuestions;
